import { combineReducers } from 'redux'

import { reducer as data } from './State/data'
import { reducer as fetching } from './State/fetching'

export default combineReducers({
  data,
  fetching,
})
